import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from './AuthContext';
import { FaSpinner } from 'react-icons/fa';

const PrivateRoute = ({ children, requireInstructor = false }) => {
    const { user, loading } = useAuth();
    const location = useLocation();

    if (loading) {
        return (
            <div className="container py-5 text-center">
                <FaSpinner className="fa-spin fa-3x text-primary mb-3" />
                <h4>Verifying your session...</h4>
            </div>
        );
    }

    if (!user) {
        return <Navigate to="/auth" state={{ from: location }} replace />;
    }

    if (requireInstructor && user.role !== 'instructor') {
        return <Navigate to="/dashboard" replace />;
    }

    return children;
};

export default PrivateRoute; 